<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5006)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5006)" />
    </g>
    <path
      d="M22.3333 12.6667H11.6667C11.4899 12.6667 11.3203 12.7369 11.1953 12.8619C11.0702 12.987 11 13.1565 11 13.3334V15.3334C11 15.5102 11.0702 15.6797 11.1953 15.8048C11.3203 15.9298 11.4899 16 11.6667 16C11.8435 16 12.013 15.9298 12.1381 15.8048C12.2631 15.6797 12.3333 15.5102 12.3333 15.3334V14H16.3333V22.6667H15C14.8232 22.6667 14.6536 22.7369 14.5286 22.8619C14.4036 22.987 14.3333 23.1565 14.3333 23.3334C14.3333 23.5102 14.4036 23.6797 14.5286 23.8048C14.6536 23.9298 14.8232 24 15 24H19C19.1768 24 19.3464 23.9298 19.4714 23.8048C19.5964 23.6797 19.6667 23.5102 19.6667 23.3334C19.6667 23.1565 19.5964 22.987 19.4714 22.8619C19.3464 22.7369 19.1768 22.6667 19 22.6667H17.6667V14H21.6667V15.3334C21.6667 15.5102 21.7369 15.6797 21.8619 15.8048C21.987 15.9298 22.1565 16 22.3333 16C22.5101 16 22.6797 15.9298 22.8047 15.8048C22.9298 15.6797 23 15.5102 23 15.3334V13.3334C23 13.1565 22.9298 12.987 22.8047 12.8619C22.6797 12.7369 22.5101 12.6667 22.3333 12.6667Z"
      fill="white" />
    <defs>
      <filter id="filter0_d_3254_5006"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5006" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5006" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5006"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#1E1E1E" />
        <stop offset="1" stop-color="#101010" />
      </linearGradient>
    </defs>
  </svg>
</template>
